class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    // Log the search parameters for debugging
    console.log('Rendering page with params:', searchParams);

    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');

    // Add loading state to the collection
    const productGridContainer = document.getElementById('ProductGridContainer');
    if (productGridContainer) {
      const collection = productGridContainer.querySelector('.collection');
      if (collection) {
        collection.classList.add('loading');
      }
    }

    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    // Parse the search parameters to check for filter parameters
    const params = new URLSearchParams(searchParams);
    const filterParams = [];
    params.forEach((value, key) => {
      if (key.startsWith('filter.')) {
        filterParams.push({ key, value });
      }
    });

    // Log the filter parameters for debugging
    console.log('Active filters:', filterParams);

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      console.log('Fetching section from URL:', url);

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }


  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');

        // Debug to see the parsed HTML
        console.log(parsedHTML);

        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html: responseText, url }];
        FacetFiltersForm.renderFilters(responseText, event);
        FacetFiltersForm.renderProductGridContainer(responseText);
        FacetFiltersForm.renderProductCount(responseText);
      });
  }


  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderReview() {
    if (window.SPR && theme.review) {
      if ($('.shopify-product-reviews-badge').length > 0) {
        return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
      }
    }
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    // Log the parsed HTML for debugging
    console.log(parsedHTML);

    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');

    if (countContainer) {
      const newCount = parsedHTML.getElementById('ProductCount');
      if (newCount) {
        countContainer.innerHTML = newCount.innerHTML;
      } else {
        console.warn('No ProductCount element found in the fetched HTML.');
        countContainer.innerHTML = '';
      }
      countContainer.classList.remove('loading');
    }

    if (countContainerDesktop) {
      const newCountDesktop = parsedHTML.getElementById('ProductCountDesktop');
      if (newCountDesktop) {
        countContainerDesktop.innerHTML = newCountDesktop.innerHTML;
      } else {
        console.warn('No ProductCountDesktop element found in the fetched HTML.');
        countContainerDesktop.innerHTML = '';
      }
      countContainerDesktop.classList.remove('loading');
    }
  }



  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    // Preserve the hash part of the URL if it exists
    const hash = window.location.hash;

    // Create the new URL with search parameters
    const newUrl = `${window.location.pathname}${searchParams && '?'.concat(searchParams)}${hash}`;

    // Update browser history
    history.pushState({ searchParams }, '', newUrl);

    // Log the URL update for debugging
    console.log('Updated URL:', newUrl);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    const params = new URLSearchParams(window.location.search);

    // Store existing filter values to preserve them
    const existingFilters = {};

    // Collect all existing filter parameters by type
    for (const [key, value] of params.entries()) {
      if (key.startsWith('filter.')) {
        if (!existingFilters[key]) {
          existingFilters[key] = [];
        }
        existingFilters[key].push(value);
      }
    }

    // Process form data
    const formFilters = {};
    formData.forEach((value, key) => {
      if (key.startsWith('filter.')) {
        if (!formFilters[key]) {
          formFilters[key] = [];
        }
        formFilters[key].push(value);
      } else {
        // For non-filter parameters, just set them
        params.set(key, value);
      }
    });

    // Clear all filter parameters to rebuild them
    for (const key in existingFilters) {
      params.delete(key);
    }

    // Merge existing filters with form filters
    for (const key in existingFilters) {
      // If this filter type is in the form, use only form values (user is updating this filter type)
      if (!formFilters[key]) {
        existingFilters[key].forEach(value => {
          params.append(key, value);
        });
      }
    }

    // Add all form filters
    for (const key in formFilters) {
      formFilters[key].forEach(value => {
        params.append(key, value);
      });
    }

    return params.toString();
  }




  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    // Collect all relevant forms
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const forms = [];
    const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

    // Process each form and gather parameters
    sortFilterForms.forEach((form) => {
      if (!isMobile) {
        if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
          const noJsElements = document.querySelectorAll('.no-js-list');
          noJsElements.forEach((el) => el.remove());
          forms.push(this.createSearchParams(form));
        }
      } else if (form.id === 'FacetFiltersFormMobile') {
        forms.push(this.createSearchParams(form));
      }
    });

    // Create a single merged parameter string from all forms
    // The createSearchParams method now handles preserving existing filters
    let finalParams = forms[0] || '';

    // If we have multiple forms, we need to merge their parameters
    if (forms.length > 1) {
      const mergedParams = new URLSearchParams();
      const allFilters = {};

      // First, collect all filter parameters from all forms
      forms.forEach(formParamString => {
        const formParams = new URLSearchParams(formParamString);

        formParams.forEach((value, key) => {
          if (key.startsWith('filter.')) {
            if (!allFilters[key]) {
              allFilters[key] = new Set();
            }
            allFilters[key].add(value);
          } else {
            // For non-filter parameters, use the last value
            mergedParams.set(key, value);
          }
        });
      });

      // Add all collected filter parameters
      for (const [key, values] of Object.entries(allFilters)) {
        values.forEach(value => {
          mergedParams.append(key, value);
        });
      }

      finalParams = mergedParams.toString();
    }

    // Update the URL with the merged parameters
    this.onSubmitForm(finalParams, event);
  }



  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();

    // Get the URL from the clicked filter's href
    const clickedUrl = event.currentTarget.href;
    const hasParams = clickedUrl.indexOf('?') !== -1;

    // If there are no parameters, just render the base URL
    if (!hasParams) {
      FacetFiltersForm.renderPage('');
      return;
    }

    // Extract the URL parameters
    const urlParams = new URLSearchParams(clickedUrl.slice(clickedUrl.indexOf('?') + 1));

    // Get current URL parameters to preserve non-filter parameters
    const currentParams = new URLSearchParams(window.location.search);

    // Determine which filter is being removed by comparing URLs
    const removedFilterKey = this.findRemovedFilter(currentParams, urlParams);

    // If we can't determine which filter was removed, just use the URL as is
    if (!removedFilterKey) {
      FacetFiltersForm.renderPage(urlParams.toString());
      return;
    }

    // Create a new set of parameters that preserves other filters
    const newParams = new URLSearchParams();

    // Copy all parameters from the clicked URL
    urlParams.forEach((value, key) => {
      // For filter parameters, we need to handle them specially
      if (key.startsWith('filter.')) {
        newParams.append(key, value);
      } else {
        // For non-filter parameters, just set them
        newParams.set(key, value);
      }
    });

    // Render the page with our new parameters
    FacetFiltersForm.renderPage(newParams.toString());
  }

  // Helper method to find which filter was removed
  findRemovedFilter(currentParams, newParams) {
    // Look for filter parameters that exist in current but not in new
    for (const [key, value] of currentParams.entries()) {
      if (key.startsWith('filter.')) {
        const newValues = newParams.getAll(key);
        if (!newValues.includes(value)) {
          return { key, value };
        }
      }
    }
    return null;
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = '';
FacetFiltersForm.searchParamsPrev = '';

window.customElements.define('facet-filters-form', FacetFiltersForm);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.noUifilter = this.noUifilter.bind(this);
  }

  connectedCallback() {
    this.noUifilter();
    this.querySelector('form').addEventListener('submit', (e) => e.preventDefault());
  }

  noUifilter() {
    const slider = this.querySelector('input[type="text"]');
    const minInput = this.querySelector('input[name="min"]');
    const maxInput = this.querySelector('input[name="max"]');
    const minPrice = parseInt(this.dataset.min);
    const maxPrice = parseInt(this.dataset.max);
    const defaultMin = parseInt(this.dataset.defaultMin) || minPrice;
    const defaultMax = parseInt(this.dataset.defaultMax) || maxPrice;

    $(slider).ionRangeSlider({
      type: "double",
      min: minPrice,
      max: maxPrice,
      from: defaultMin,
      to: defaultMax,
      grid: true,
      grid_margin: false,
      onFinish: (data) => {
        minInput.value = data.from;
        maxInput.value = data.to;
        this.dispatchEvent(new Event("input"));
      }
    });
  }
}

window.customElements.define('price-range', PriceRange);

// Debounce function
function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}
